import Flickity from 'flickity'
import 'flickity/css/flickity.css'
import {VideoPlayer} from '../videoplayer'

import register from '../../util/init'
import {addHandler} from '../../util/scroll_resize'
import {toggle, next, prev, getOffset, fakeLazyLoad, closest} from '../../util/tools'
import {PHONE_MAX} from '../constants'
import AjaxLoader from '../../util/ajax_util'
import {updateLinkState} from '../../util/link_state'
import {calculateSiteWidth} from '../site'

class initPage {
  constructor (container) {
    this.container = container // main > article
    this.gallery = container.querySelector('.gallery')
    this.nextProject = this.gallery.getAttribute('data-nextproject')
    this.windowWidth = null
    this.videoInstances = {}
    // this.flickityPaginate = null
    this.indexTrigger = document.querySelector('.index-trigger')
    this.paginator = document.querySelector('#index .images .paginator')

    // bind index(navigation) trigger
    document.querySelectorAll('.index-trigger, .alt-index-trigger').forEach((indexTrigger) => {
      indexTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        toggle(document.body, 'index-visible', this.indexToggleCallback, this)
      })
    })

    // splash -> start setup
    container.querySelectorAll('.splash .start a:not(.alt-index-trigger)').forEach((startTrigger) => {
      // bind start click
      startTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        const firstItem = container.querySelector('.gallery .gallery-item')
        const id = firstItem.getAttribute('data-galleryitem')
        this.hijackStartGallery(firstItem)
        this.setIndexCurrentState(id)
      })
    })

    // track the mouse movement
    this.trackMouseMove()

    // gallery items setup
    container.querySelectorAll('.gallery-item').forEach((galleryItem) => {
      // bind next/previous click
      galleryItem.querySelectorAll('.previous-item, .next-item').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          if (this.windowWidth > PHONE_MAX) {
            e.preventDefault()
            // first check if the caption is open if it is
            // close it, and prevent further action
            const preventLoad = this.toggleCaption(galleryItem, true)
            if (!preventLoad) {
              // loop = false for next but is true for previous
              const requestedItem = trigger.classList.contains('next-item') ? next(galleryItem, false) : prev(galleryItem)
              if (requestedItem) {
                // load next item
                const id = requestedItem.getAttribute('data-galleryitem')
                this.hijackGalleryLoad(requestedItem)
                this.setIndexCurrentState(id)
              } else if (this.nextProject) {
                // load next project
                galleryItem.classList.remove('current-item')
                window.location = this.nextProject
              }
            }
          }
        })
      })
    })
    // bind gallery keypress left/right arrow
    document.addEventListener('keyup', (e) => {
      const currentItem = this.gallery.querySelector('.gallery-item.current-item')
      if (this.windowWidth > PHONE_MAX) {
        if (e.which === 37) {
          // left (previous)
          let trigger = currentItem.querySelector('.previous-item')
          if (trigger) {
            e.preventDefault()
            trigger.click()
          }
        } else if (e.which === 39) {
          // right (next)
          e.preventDefault()
          currentItem.querySelector('.next-item').click()
        }
      }
    })

    // index (navigation) image setup
    document.querySelectorAll('#index .project-image a').forEach((galleryTrigger) => {
      // bind click event
      galleryTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        const id = galleryTrigger.getAttribute('data-galleryitem')
        const selectedItem = container.querySelector(`.gallery-item[data-galleryitem="${id}"]`)
        // start gallery if on the splash
        if (document.body.classList.contains('display-splash')) {
          document.body.classList.remove('display-splash')
          document.body.classList.add('display-block')
        }
        this.hijackGalleryLoad(selectedItem)
        this.setIndexCurrentState(id)
        if (this.windowWidth < PHONE_MAX) {
          document.documentElement.scrollTop = getOffset(selectedItem).top - 100
          document.body.scrollTop = getOffset(selectedItem).top - 100
        }

        // short delay then close index(navigation)
        window.setTimeout(() => {
          this.indexTrigger.click()
        }, 1300)
      })
    })
    // index (navigation) pageload setup
    document.querySelectorAll('#index header .profile-triggers a,\
                               #index header .writing-triggers a:not(.introduction-link)').forEach((trigger) => {
      // bind click event
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        if (!trigger.classList.contains('current')) {
          this.hijackIndexPageLoad(trigger, this)
        }
      })
    })
    // index (navigation) article (writing) close
    document.querySelectorAll('#index article .close, #index .introduction-link').forEach((trigger) => {
      // bind click event
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleWriting(false)
      })
    })
    // INIT bind tablet-plus footer events (#footer - site)
    this.bindFooterEvents()
    // INIT bind phone footer events (.gallery-item footer)
    this.gallery.querySelectorAll('.gallery-item footer').forEach((footer) => {
      this.bindFooterEvents(footer)
    })
    // phone - track the current state
    this.trackCurrentProjectScroll(this.gallery.querySelectorAll('.gallery-item'))
    // hijack the 'home' click so it triggers a historyback action (/ or /students)
    document.querySelectorAll('.back').forEach((backLink) => {
      if (window.document.referrer &&
          (window.document.referrer === `${window.location.origin}/` ||
           window.document.referrer === `${window.location.origin}/students`)) {
        backLink.addEventListener('click', (e) => {
          e.preventDefault()
          window.history.back()
        })
      }
    })
    // bind index paginate items
    document.querySelectorAll('#index .images .paginator a').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault()
        this.paginate(a, true)
      })
    })
    // INIT all videos
    this.gallery.querySelectorAll('.gallery-item .video-player').forEach((videoPlayer) => {
      const id = closest(videoPlayer, '.gallery-item').getAttribute('data-galleryitem')
      this.videoInstances[id] = new VideoPlayer(videoPlayer)
    })
  }
  /**
  * init handler - resize
  *
  * @param {int}, width
  * @param {int}, height
  */
  resize (w, h) {
    this.windowWidth = w
    // preload the nessesary items (phone: all, tablet-plus: next 'count')
    this.preloadGalleryItems(this.gallery, {})
    this.setupVideo(this.gallery.querySelector('.gallery-item.current-item'), false)
    // this.enableDisablePaginateFlickity(w)
  }
  /**
  * init handler - scroll
  *
  * @param {int}, top
  * @param {int}, left
  */
  scroll (top, left) {}

  /**
  * paginate items eg. 01 02 03 in contents, assumes it's followed by
  * multiple .page items,
  *
  * @param {htmlElement}, .paginator > a
  * @param {boolean}, triggerFlickitySelect
  */
  paginate (selectedTrigger, triggerFlickitySelect) {
    // strip out the current states (trigger + page)
    this.paginator.querySelector('a.current-page').classList.remove('current-page')
    this.paginator.parentElement.querySelector('.page.current-page').classList.remove('current-page')

    // add classes to the new (trigger + page)
    const selectedIndex = selectedTrigger.getAttribute('data-page')
    const selectedPage = this.paginator.parentElement.querySelector(`.page[data-page="${selectedIndex}"]`)
    selectedTrigger.classList.add('current-page')
    selectedPage.classList.add('current-page')

    // if (triggerFlickitySelect && this.flickityPaginate) {
    //   this.flickityPaginate.select(selectedIndex - 1)
    // }
  }
  /**
  * index (navigation) > paginate uses flickity on phone but not descktop
  *
  * @param {int} windowWidth
  */
  enableDisablePaginateFlickity (w) {
    if (w > PHONE_MAX && this.flickityPaginate) {
      // tablet-plus
      this.flickityPaginate.destroy()
      this.flickityPaginate = null
    } else if (w <= PHONE_MAX && !this.flickityPaginate) {
      // phone
      const paginate = document.querySelector('#index .images .pages')
      const options = {
        freeScrollFriction: 0.075,
        dragThreshold: 80,
        selectedAttraction: 0.025,
        friction: 0.28,
        cellAlign: 'left',
        // contain: true,
        pageDots: false,
        prevNextButtons: false,
        on: {
          ready: function () {
            // if 'current-page' is not first set it
            const index = document.querySelector(`#index .images .paginator .current-page`).getAttribute('data-page')
            this.select(index - 1)
          },
          settle: (index) => {
            // recall the 'desktop' paginator
            const current = document.querySelector(`#index .images .paginator [data-page='${index + 1}']`)
            this.paginate(current, false)
          }
        }
      }
      this.flickityPaginate = new Flickity(paginate, options)
    }
  }
  /**
  * override the splash start page load, and transition to display-block
  *
  * @param {htmlElement}, .gallery-item
  * @return {function instance} InfScr
  */
  hijackStartGallery (galleryItem) {
    const url = galleryItem.getAttribute('data-url')

    // update the current url, to push or replace state?
    window.history.replaceState({ns: 'placeintime'}, null, url)

    // switch 'state'
    document.body.classList.remove('display-splash')
    document.body.classList.add('display-block')

    // track the mouse movement
    // this.trackMouseMove()
  }
  /**
  * gallery item click defaults to a standard page load when clicked,
  * we're going to fake this switch to make it more seamless
  *
  * @param {htmlElement}, .gallery-item
  * @return {function instance} InfScr
  */
  hijackGalleryLoad (galleryItem) {
    const url = galleryItem.getAttribute('data-url')
    const previousItem = this.gallery.querySelector('.current-item')

    // pause previous video it there is one
    this.pauseCurrentVideo()

    // update the current url, to push or replace state?
    window.history.replaceState({ns: 'placeintime'}, null, url)

    // swap current class
    previousItem.classList.remove('current-item')
    galleryItem.classList.add('current-item')
    // recall to preload the next images
    this.preloadGalleryItems(this.gallery)
    // replace #footer with current item footer
    const footerContent = galleryItem.querySelector('footer') ? galleryItem.querySelector('footer').innerHTML : '&nbsp;'
    document.getElementById('footer').innerHTML = footerContent
    // bind events
    this.bindFooterEvents()
    // if there is a current video play it

    this.setupVideo(galleryItem, true)
  }
  /**
  * pause the playing video, when interacting with elements
  * @param {htmlElement} container
  *
  */
  pauseCurrentVideo () {
    for (const i in this.videoInstances) {
      this.videoInstances[i].pause()
    }
  }
  /**
  * setup for video items
  *
  * @param {htmlElement}, galleryItem
  */
  setupVideo (galleryItem, triggerPlay) {
    const videoPlayer = this.videoInstances[galleryItem.getAttribute('data-galleryitem')]
    if (videoPlayer) {
      // set the video player controls width to the width of the poster (video not loaded yet)
      // in some instances this will be 0 while loazyloading image renders. so we loop interval
      const videoPoster = galleryItem.querySelector('.poster img')
      const videoControlsProgress = galleryItem.querySelector('.video-controls .progress-wrap')
      const videoControlsLeft = galleryItem.querySelector('.video-controls .left')
      let setControlWidth = window.setInterval((vp) => {
        const videoPosterWidth = videoPoster.clientWidth
        if (videoPosterWidth !== 0) {
          videoControlsProgress.style.maxWidth = `${videoPosterWidth}px`
          videoControlsLeft.style.maxWidth = `${videoPosterWidth}px`
          window.clearInterval(setControlWidth)
        }
      }, 200, videoPoster)
      if (this.windowWidth > PHONE_MAX) {
        // autoplay the video
        window.setTimeout((vp) => {
          if (triggerPlay) {
            vp.play()
          }
          // stop this from infinately looping if it hasn't already
          if (setControlWidth) {
            window.clearInterval(setControlWidth)
          }
        }, 1800, videoPlayer)
      }
    }
  }
  /**
  * to prevent excess image load we can preload a few at a time ass required
  * replace data-src/data-srcset/data-sizes
  *
  * @param {htmlElement}, .gallery, usually the 'current' item
  * @param {object}, options {
  *                     count: INT, (inclusive off current)
  *                     prefix: STRING, (switch the correct values out phone/tablet-plus)
  *                  }
  * @return {array} InfScr
  */
  preloadGalleryItems (gallery, options = {}) {
    const {
      count = 3, // must be odd (even on both sides + self)
      prefix = this.windowWidth <= PHONE_MAX ? 'micro' : 'macro'
    } = options

    let items = [...gallery.querySelectorAll('.gallery-item')]
    let slice = items
    const current = gallery.querySelector('.current-item')
    const currentIndex = items.indexOf(current)
    if (this.windowWidth > PHONE_MAX) {
      // tablet-plus only limit the amount of preloaded items
      if (currentIndex !== 0) {
        // reshuffle the items so current is the first in the array
        items = [...items.slice(currentIndex - ((count - 1) / 2), items.length), ...items.slice(0, currentIndex - ((count - 1) / 2))]
      }
      slice = items.slice(0, count)
    }

    for (const item of slice) {
      const img = item.querySelector('img')
      if (img) {
        // loop throught and replace the attributes
        const attributes = ['src', 'srcset', 'sizes']
        for (const a of attributes) {
          // if (img.hasAttribute(`data-${prefix}-${a}`)) {
          // don't remove the data-attr,
          // as we will use these to update the state of each image
          // TODO add a visual loading state here
          img.setAttribute(a, img.getAttribute(`data-${prefix}-${a}`))
          // }
        }
        fakeLazyLoad(closest(img, '.lazyload'))
      }
    }
    // if (PHONE_MAX) {

    // }
  }
  /**
  * ...
  *
  * @param {bool} open, returns true if opening, false if closing
  * @param {Class} that, this(InitPage)
  */
  indexToggleCallback (open, that) {
    // TODO reset current item url on close (writing might reset)
    if (!open) {
      // closeing
      // flick back to introduction
      that.toggleWriting(false)
      calculateSiteWidth(that.windowWidth)
    } else {
      // opening
      const currentItem = that.gallery.querySelector('.current-item')
      that.toggleCaption(currentItem, true)
      if (that.flickityPaginate) {
        that.flickityPaginate.resize()
      }
      that.pauseCurrentVideo()
    }
  }
  /**
  * when swithing from one gallery-item to another callback to
  * set the current state of the pagination
  *
  * @param {int}, id/pk
  */
  setIndexCurrentState (id) {
    const paginator = document.querySelector('#index .images')
    const selectedTrigger = paginator.querySelector(`[data-galleryitem="${id}"]`)
    if (selectedTrigger) {
      // strip out the cuurent-image and current-page
      paginator.querySelectorAll('.current-page, .current-image').forEach((c) => {
        c.classList.remove('current-page', 'current-image')
      })
      // update image
      selectedTrigger.classList.add('current-image')
      // update page (li(.project-image) > ul(.page))
      const pageId = selectedTrigger.parentElement.parentElement.getAttribute('data-page')
      paginator.querySelectorAll(`[data-page="${pageId}"]`).forEach((c) => {
        c.classList.add('current-page')
      })
    } else {
      // in some instance (text item) we don't want to update page current state
      if (paginator.querySelector('.current-image')) {
        paginator.querySelector('.current-image').classList.remove('current-image')
      }
    }
  }
  /**
  * Prevent page load for writing/people, just grab the content via ajax request
  * and slap it in place, AjaxLoader handles url updates
  *
  * @param {htmlElement}, <a>
  * @param {Class}, this(InitPage) > that
  */
  hijackIndexPageLoad (trigger, that) {
    const url = trigger.getAttribute('href')
    const ajax = new AjaxLoader('placeintime', function (bodyString) {
      // DISABLED the folloing has issues with &lsquo; ??
      // const parser = new DOMParser()
      // const newBody = parser.parseFromString(bodyString, "text/xml")
      let tempBody = document.createElement('div')
      tempBody.innerHTML = bodyString

      const newWriting = tempBody.querySelector('#writing')
      const currentWriting = document.querySelector('#writing')

      currentWriting.innerHTML = newWriting.innerHTML
      // reset links
      updateLinkState(document.querySelectorAll('#index header'))
      // update state classes
      that.toggleWriting(newWriting.getAttribute('data-state-class'))
    },
    {
      onBeforeLoad: function (url) {
        // console.log('before')
      }
    })
    ajax.load(url, null)
  }
  /**
  * strip/add the writing classes
  *
  * @param {bool / class name}, add = false/'display-writing'
  */
  toggleWriting (add) {
    document.body.classList.remove('display-writing', 'display-profile')
    if (add) {
      document.body.classList.add(add)
    } else {
      // clear writing trigger current
      const currentTrigger = document.querySelector('#index header a:not(.introduction-link).current')
      if (currentTrigger) {
        currentTrigger.classList.remove('current')
        document.querySelector('#index header a.introduction-link').classList.add('current')
      }
      // update the current url (gallery item or splash)
      const current = this.gallery.querySelector('.gallery-item.current-item') || document.querySelector('splash')
      const url = current.getAttribute('data-url')
      window.history.replaceState({ns: 'placeintime'}, null, url)
    }
  }
  /**
  * footer dom elements are appended via ajax
  * every time we need bind them fresh
  * however on phone we bind the gallery-item footer
  *
  * @param {htmlElement} galleryItemFooter
  */
  bindFooterEvents (footer) {
    // bind caption toggle
    const captionTrigger = footer ? footer.querySelector('.caption-trigger') : document.querySelector('#footer .caption-trigger')
    if (captionTrigger) {
      captionTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        const id = captionTrigger.getAttribute('data-galleryitem')
        const galleryItem = this.gallery.querySelector(`.gallery-item[data-galleryitem="${id}"]`)
        this.toggleCaption(galleryItem)
      })
    }
  }
  /**
  * open and close the caption, slide image across
  * makes the assuption figure has no other style attr to consider
  *
  * @param {htmlElement} galleryItem
  * @param {bool\null} forceClose, to force caption closed e.g. next slide call
  * @return {bool} isOpen
  */
  toggleCaption (galleryItem, forceClose = null) {
    const figure = galleryItem.querySelector('figure')
    const isOpen = galleryItem.classList.contains('display-caption')
    const transitionendPrefixed = ['transitionend', 'webkitTransitionEnd']
    const transitionCallbackClose = (e) => {
      galleryItem.classList.remove('transitioning-caption')
      if (e) {
        // on phone we don't pass the event in
        transitionendPrefixed.forEach(event => {
          e.target.removeEventListener(event, transitionCallbackClose, true)
        })
      }
    }
    const transitionCallbackOpen = (e) => {
      if (this.windowWidth > PHONE_MAX) {
        // fix/lock the position of the figure
        const currentOffset = getOffset(figure)
        const currentHeight = figure.offsetHeight
        const applyStyle = `height: ${parseInt(currentHeight)}px;
                            top: ${parseInt(currentOffset.top)}px;
                            left: ${parseInt(currentOffset.left)}px;
                            position: fixed;`
        figure.style.cssText = applyStyle
      }
      galleryItem.classList.remove('transitioning-caption')
      if (e) {
        // on phone we don't pass the event in
        transitionendPrefixed.forEach(event =>
          e.target.removeEventListener(event, transitionCallbackOpen, true)
        )
      }
    }
    // prevent multiple clicks
    if (figure && !galleryItem.classList.contains('transitioning-caption')) {
      if (isOpen) {
        // close
        galleryItem.classList.add('transitioning-caption')
        if (this.windowWidth > PHONE_MAX) {
          transitionendPrefixed.forEach(event =>
            figure.addEventListener(event, transitionCallbackClose, true)
          )
        } else {
          // phone call this instantly
          transitionCallbackClose()
        }
        galleryItem.classList.remove('display-caption')
        figure.style.cssText = ''
      } else if (!isOpen && !forceClose) {
        // open
        galleryItem.classList.add('transitioning-caption')
        if (this.windowWidth > PHONE_MAX) {
          transitionendPrefixed.forEach(event =>
            figure.addEventListener(event, transitionCallbackOpen, true)
          )
        } else {
          // phone call this instantly
          transitionCallbackOpen()
        }
        galleryItem.classList.add('display-caption')
      }
    }
    return isOpen
  }
  /**
  * phone - when you scroll - update the 'current project'

  * @param {htmlElement} projects
  * @param {decimal} point - % of height
  *
  */
  trackCurrentProjectScroll (projects, point = 0.4) {
    projects.forEach((project) => {
      let enable
      let projectStart
      let projectEnd
      let triggerPoint
      addHandler({
        resize: (w, h) => {
          projectStart = getOffset(project).top
          projectEnd = projectStart + project.clientHeight
          triggerPoint = h * point
          enable = w < PHONE_MAX
        },
        scroll: (top, left) => {
          if (enable) {
            if ((top + triggerPoint) > projectStart &&
                (top + triggerPoint) < projectEnd) {
              if (!project.classList.contains('current-item')) {
                const id = project.getAttribute('data-galleryitem')
                this.hijackGalleryLoad(project)
                this.setIndexCurrentState(id)
              }
            }
          }
        }
      }, true)
    })
  }
  /**
  * track  the mouse movement, and show hide the header/footer content

  *
  */
  trackMouseMove () {
    // NOTE can't detect mousemove without moving so makes init a bit of an issue, settle on touch
    if (!window.Modernizr.touch) {
      let tracking = true
      let interval = 100 // ms
      let initialised = false

      let currentPosition = null
      let startPosition = null
      let previousPosition = null

      let minimumMovement = 30 // px
      let startTimer = null // ms (timestamp)
      let resetTimer = 4000 // ms - changes after init

      this.gallery.addEventListener('mouseenter', (e) => {
        tracking = true
      })
      this.gallery.addEventListener('mousemove', (e) => {
        currentPosition = {
          x: e.pageX,
          y: e.pageY
        }
      })
      this.gallery.addEventListener('mouseleave', (e) => {
        tracking = false
        document.body.classList.remove('dead-mouse')
      })

      window.setInterval(() => {
        let deltaMovement
        if (tracking) {
          // check if we've moved (aviod calculations)
          if (currentPosition && currentPosition !== previousPosition) {
            // moving ...
            // set the start position if it doesn't exist, then bail
            if (startPosition === null) {
              startPosition = previousPosition = currentPosition
            } else {
              // track movement from start position
              deltaMovement = {
                x: currentPosition.x - startPosition.x,
                y: currentPosition.y - startPosition.y
              }
              // TODO check if greter than minimumMovement
              let movement = Math.abs(deltaMovement.x + deltaMovement.y)
              if (movement > minimumMovement) {
                // console.log(`movement ${movement}`)
                document.body.classList.remove('dead-mouse')
              }
              // keep reseting the timer
              startTimer = null
            }
            previousPosition = currentPosition
          } else {
            // not moving ...
            // no point tracking if we've reset
            if (startPosition || !initialised) {
              // set the init timer
              if (startTimer === null) {
                startTimer = Date.now()
              }
              let timeDelta = Date.now() - startTimer
              if (timeDelta < resetTimer) {
                // increment time we've been sitting still
                // console.log(`timer ${timeDelta}`)
              } else {
                // reset startPosition, for the next 'movement'
                startPosition = previousPosition = currentPosition = null
                document.body.classList.add('dead-mouse')
                if (!initialised) {
                  initialised = true
                  resetTimer = 1000 // ms
                }
              }
            }
          }
        }
      }, interval)
    }
  }
}
register('.project-content', initPage)



// WEBPACK FOOTER //
// ./assets/j/src/projects/project.js